import type { FaireProductEntity } from "../../entity_types/product";

export const p_tfwvz9ah57: FaireProductEntity = {
  token: "p_tfwvz9ah57",
  type: "product",
  name: "TOPANGA",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/4bf55793e03a57c8d679a87039b9e22dde68c2ce4eb2f00f3d1d79d78cd46c57.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa5c52d8054e2c289682e12b82647ebb1d4a9731e8225fb926acb07824a06081.jpeg",
    "https://cdn.faire.com/fastly/3127e6143aaa1d0c3638408ad62112ae100bd7eb381536a77c6d6920056b36e3.jpeg",
    "https://cdn.faire.com/fastly/58272b75a34a5a46b5ce3b210df9f6aa2a1afa9d77c34dd2c11f33b14ddda41a.jpeg",
    "https://cdn.faire.com/fastly/c2a7ee79d4192f1857666a0ed2319956f0864f3e5fdca09b39b9f225a794a1c8.jpeg",
  ],
  priceDollars: 19,
  description:
    "A fresh, earthy scent inspired by the untamed nature of Topanga Canyon. Perched between Malibu and Calabasas, this unfettered land is rife with wild sage, lavender, cedar and pine. Softened with top notes of fig, lily and fresh green leaves and grounded with undertones of fir, patchouli and sweet incense.\n\ngreen leaves, wild sage, fig, lavender, fir, cedar, incense\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n8.4 ounces (228g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T14:47:20.736Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
